import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { v4 as uuidv4 } from 'uuid';
import { Dialog } from "primereact/dialog";

import ValidateCategoryModal from "./ValidateCategory";
import MaterialsPreviousTransactions from "../../../SendRequisition/Components/MaterialsPreviousTransactions";
import StructuredMaterialSpecs from "./StructuredMaterialSpecs";

import { AutoCompleteField, Button, DropDownField, TextInputField, CheckboxField } from "../../../../helpers"
import Tooltip from "../../../../helpers/Tooltip";

import { raiseToast } from "../../../../services/redux/reducers/toast/toast";
import { updatedMaterialMasterTemp, materialIdExistsInOtherRequirement } from '../../../../services/api/materialMasterTemp'
import { validateMaterialCategoryUsingParser } from "../../../../services/api/materialCategory";
import { getGoogleUserChatUri } from "../../../../services/api/googleChat";

import googleChatIcon from "../../../../images/google_chat_icon.png"

import { getFullName, getMaterialMasterApproverTooltipHTML, round, sortArrayOfObjectsInAscendingDateOrder } from "../../../../utils";
import { calculateStockGSTAndPrice, checkPermissions, getReversePercentile } from "../../../../utils";
import { getPMCompanyConfig } from "../../../../setup/pmCompanyConfig";


const ProductsListItems = (props) => {
    const {
        buyerPO,
        buyerPOItem,
        sellerCompanyDetails,
        materialDetails,
        sellerReqs,
        sellerReqItems,
        relatedSellerReqItems,
        setSellerReqItems,
        buyerQuoteItems,
        displaySellerPOs,
        setDisplaySellerPOs,
        displaySellerPOItems,
        setDisplaySellerPOItems,
        setAllMaterialDetails,
        brandData,
        procmartCompanyBillAddrs,
        companyWarehouses,
        handleUseStock,
        stockMaterials,
        initialMaterialDetails,
        lowPriorityMaterials,
        allMaterialDetails,
        setIsLoading,
        materialCategories,
        initialSellerReqItems,
        materialIdTeam,
        smartStockMoves,
        PMBranches,
        partialSpecsApproval,
        approvalInstances,
        buyerPOPunchItems,
        buyerReq,
        materialSpecsMatchesData,
        tempMaterialItems,
        pastSellerPOMaterialTransactions,
        PMCompanyConfig,
        pastSellerPOsInfo,
        nonRoutedSellerPOsInfo,
        approvals,
    } = props
    
    const [isCategoryValidationVisible, setIsCategoryValidationVisible] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [predictedCategory, setPredictedCategory] = useState(null)
    const [searchedMaterialBrands, setSearchedMaterialBrands] = useState([])
    const [visibleStructuredMaterialSpecs, setVisibleStructuredMaterialSpecs] = useState(false)
    const [tiggerPastTransactions, setTiggerPastTransactions] = useState(false)

    const materialSpecifications = useSelector(state => state.common.materialSpecifications)
    const userId = useSelector((state) => state.userDetails.userId)
    const vendorRateContracts = useSelector(state => state.common.vendorRateContracts)

    const pmCompanyConfig = getPMCompanyConfig(buyerPO.pmCompanyId)

    const urdOptions = [
        { label: "Yes", value: "Yes" },
        { label: "No", value: "No" }
    ]

    
    let gstRates = pmCompanyConfig.GSTRates
    let gstOptions = []
    gstRates.map(eachGSTRate => gstOptions.push({label: eachGSTRate.toString(), value: eachGSTRate}))

    const dispatch = useDispatch()

    const userDetails = useSelector((state) => state.userDetails)

    const getRemainingQty = (availableQty, sellerReqItems) => {
        let totalSum = 0
        sellerReqItems.forEach(eachReqItem => {
            totalSum += parseFloat(eachReqItem.createSellerPOQty) ? parseFloat(eachReqItem.createSellerPOQty) : 0
        })

        return round(parseFloat(availableQty) - totalSum)
    }

    const getIsWarehouseShipAddr = (sellerPOItems) => {
        const shipAddrIds = sellerPOItems.map(eachShipAddr => eachShipAddr.shipAddrId)

        const pmShipAddrIds = companyWarehouses.map(eachWarehouse => eachWarehouse.shipAddrId)
        const isWarehouseShipAddr = shipAddrIds.some(eachShipAddrId => {
            if (pmShipAddrIds.includes(eachShipAddrId)) {
                return true
            }
            return false
        })

        return isWarehouseShipAddr
    }

    const handleSellerQuantity = (e, id, relatedSellerReq, displaySellerPOs, setDisplaySellerPOs, buyerPO, displaySellerPOItems, setDisplaySellerPOItems, buyerPOItem, relatedSellerReqItems, relatedSellerCompanyDetails) => {
        if(!tiggerPastTransactions){
            setTiggerPastTransactions(true)
        }
        
        const relatedCompanySellerDetails = sellerCompanyDetails.find(eachSeller => eachSeller.companyId === relatedSellerReq.companyId)

        let invalidQtyText = ''
        const updatedSellerReqItems = sellerReqItems.map(eachSellerReqItem => {
            const remainingSellerReqItems = relatedSellerReqItems.filter(eachSelleReqItem => eachSelleReqItem.sellerReqItemId !== id)
            const remainingQty = getRemainingQty(buyerPOItem?.availableQty, remainingSellerReqItems)

            const relatedSellerReqItem = relatedSellerReqItems.find(eachSellerReqItem => eachSellerReqItem.sellerReqItemId === id)
            let sellerQty = parseFloat(e.target.value)

            if (sellerQty > parseFloat(relatedSellerReqItem.quotQty) || sellerQty > remainingQty) {
                if (remainingQty >= parseFloat(relatedSellerReqItem.quotQty)) {
                    sellerQty = parseFloat(relatedSellerReqItem.quotQty)
                    e.target.value = parseFloat(relatedSellerReqItem.quotQty)
                    invalidQtyText = `Max seller quote quantity is ${relatedSellerReqItem.quotQty}`
                } else {
                    sellerQty = parseFloat(remainingQty)
                    e.target.value = parseFloat(remainingQty)
                    invalidQtyText = "Input quantity exceeds available quantity"
                }
            }

            //calcultaion for total amount with and without tax
            const totalAmountBeforeTax = round(sellerQty * eachSellerReqItem.quotUnitPrice)
            const totalTax = round((sellerQty * eachSellerReqItem.quotUnitPrice) * round(eachSellerReqItem.quotGSTRate / 100))

            if (eachSellerReqItem.sellerReqItemId === id) {
                const relatedDisplaySellerPOItem = displaySellerPOItems.find(eachSellePOItem => eachSellePOItem.sellerReqItemId === id)
                if (relatedDisplaySellerPOItem) {  //Update displaySellerPO
                    if (sellerQty === 0 || e.target.value === '') {

                        const updatedSellerPOItems = displaySellerPOItems.filter(eachSellePOItem => eachSellePOItem.sellerReqItemId !== id)
                        setDisplaySellerPOItems(updatedSellerPOItems)

                        const isDisplaySellerPOItemsPresent = updatedSellerPOItems.some(eachSellePOItem => eachSellePOItem.displaySellerPOId === relatedDisplaySellerPOItem.displaySellerPOId)
                        if (!isDisplaySellerPOItemsPresent) {
                            const updatedDisplaySellerPOs = displaySellerPOs.filter(eachSellerPo => eachSellerPo.displaySellerPOId !== relatedDisplaySellerPOItem.displaySellerPOId)
                            setDisplaySellerPOs(updatedDisplaySellerPOs)
                        }
                        else {
                            const relatedDisplaySellerPOItems = updatedSellerPOItems.filter(eachSellerPOItem => eachSellerPOItem.displaySellerPOId === relatedDisplaySellerPOItem.displaySellerPOId)
                            const isWarehouseShipAddr = getIsWarehouseShipAddr(relatedDisplaySellerPOItems)

                            let incoTermId = null
                            if (!isWarehouseShipAddr) {
                                incoTermId = 1
                            }

                            const updatedDisplaySellerPOs = displaySellerPOs.map(eachSellerPo => {
                                if (eachSellerPo.displaySellerPOId == relatedDisplaySellerPOItem.displaySellerPOId) {
                                    return { ...eachSellerPo, incoTermId: incoTermId, shipAddrId: null }
                                }
                                return eachSellerPo
                            })
                            setDisplaySellerPOs(updatedDisplaySellerPOs)
                        }

                        eachSellerReqItem.smartUnitPrice = eachSellerReqItem.quotUnitPrice
                        eachSellerReqItem.smartGSTRate = eachSellerReqItem.quotGSTRate

                    } else {
                        const updatedDisplaySellerPOItems = displaySellerPOItems.map(eachSellePOItem => {
                            if (eachSellePOItem.sellerReqItemId === id) {
                                let calculatedUnitPrice = eachSellePOItem.unitPrice
                                let calculatedGSTTRate = eachSellePOItem.GSTRate

                                let smartStockMovesToConsume = []
                                const relatedDisplaySellerPO = displaySellerPOs.find(eachSellerPO => eachSellerPO.displaySellerPOId === eachSellePOItem.displaySellerPOId)
                                if (relatedDisplaySellerPO.companyId === relatedDisplaySellerPO.pmCompanyId) {
                                    const relatedPMBranch = PMBranches.find(eachPMBranch => eachPMBranch.branchId === relatedSellerReq.branchId)

                                    const relatedSmartStockMoves = smartStockMoves.filter(eachSmartStockMove => eachSmartStockMove.materialId === eachSellePOItem.materialId && eachSmartStockMove.warehouseId === relatedPMBranch.warehouseId)

                                    const { unitPrice, GSTRate, consumableSmartStockMoves } = calculateStockGSTAndPrice(e.target.value, relatedSmartStockMoves)
                                    calculatedUnitPrice = unitPrice
                                    calculatedGSTTRate = GSTRate
                                    smartStockMovesToConsume = consumableSmartStockMoves
                                }

                                eachSellerReqItem.smartUnitPrice = calculatedUnitPrice
                                eachSellerReqItem.smartGSTRate = calculatedGSTTRate

                                return { 
                                    ...eachSellePOItem, 
                                    qty: e.target.value, 
                                    itemAmountBeforeTax: totalAmountBeforeTax, 
                                    itemAmountWithTax: round(totalAmountBeforeTax + totalTax),
                                    unitPrice: calculatedUnitPrice,
                                    GSTRate: calculatedGSTTRate,
                                    smartStockMoves: smartStockMovesToConsume
                                }
                            }
                            return eachSellePOItem
                        })
                        setDisplaySellerPOItems(updatedDisplaySellerPOItems)

                        const relatedDisplaySellerPOItems = updatedDisplaySellerPOItems.filter(eachSellerPOItem => eachSellerPOItem.displaySellerPOId === relatedDisplaySellerPOItem.displaySellerPOId)
                        const isWarehouseShipAddr = getIsWarehouseShipAddr(relatedDisplaySellerPOItems)

                        let incoTermId = null
                        if (!isWarehouseShipAddr) {
                            incoTermId = 1
                        }

                        const updatedDisplaySellerPOs = displaySellerPOs.map(eachSellerPo => {
                            if (eachSellerPo.displaySellerPOId == relatedDisplaySellerPOItem.displaySellerPOId) {
                                return { ...eachSellerPo, incoTermId: incoTermId, shipAddrId: null }
                            }
                            return eachSellerPo
                        })
                        setDisplaySellerPOs(updatedDisplaySellerPOs)
                    }

                }
                else {  //Create displaySellerPO
                    const sellerPOTDSSection = pmCompanyConfig.canApplyTds194Q && relatedSellerCompanyDetails.tdsSection194q ? "194Q" : null
                    const sellerPOTDSValue = pmCompanyConfig.canApplyTds194Q && relatedSellerCompanyDetails.tdsSection194q ? 0.1 : null
                    const sellerPOTDSSectionId = pmCompanyConfig.canApplyTds194Q && relatedSellerCompanyDetails.tdsSection194q ? 4 : null

                    const sellerBillAddrId = relatedSellerCompanyDetails.sellerBillAddrrDetails?.length === 1 ? relatedSellerCompanyDetails.sellerBillAddrrDetails[0].billAddrId : null

                    if (sellerQty > 0) {
                        let relatedDisplaySellerPO = displaySellerPOs.find(eachSellerPo => eachSellerPo.sellerReqId === eachSellerReqItem.sellerReqId)

                        let paymentTermsLoc = ''
                        let paymentTerms = null
                        if (relatedCompanySellerDetails?.branchPaymentTerms && Object.keys(relatedCompanySellerDetails?.branchPaymentTerms).length > 0) {
                            if (typeof (relatedCompanySellerDetails?.branchPaymentTerms) === "string") {
                                paymentTerms = JSON.parse(relatedCompanySellerDetails?.branchPaymentTerms)
                                paymentTermsLoc = 'Branch'
                            }
                            else if (typeof (relatedCompanySellerDetails?.branchPaymentTerms) === "object") {
                                paymentTerms = relatedCompanySellerDetails?.branchPaymentTerms
                                paymentTermsLoc = 'Branch'
                            }
                        }
                        else if (relatedCompanySellerDetails?.paymentTerms) {
                            if (typeof (relatedCompanySellerDetails?.paymentTerms) === "string") {
                                paymentTerms = JSON.parse(relatedCompanySellerDetails?.paymentTerms)
                                paymentTermsLoc = 'Company'
                            }
                            else if (typeof (relatedCompanySellerDetails?.paymentTerms) === "object") {
                                paymentTerms = relatedCompanySellerDetails?.paymentTerms
                                paymentTermsLoc = 'Company'
                            }
                        }

                        const relatedPMState = procmartCompanyBillAddrs?.find(eachBillAddr => eachBillAddr.billAddrId === buyerPO?.pmBillAddrId)

                        let relatedPMStateId = relatedPMState?.stateId
                        if (relatedDisplaySellerPO && relatedDisplaySellerPO.companyId === relatedDisplaySellerPO.pmCompanyId) {
                            relatedPMStateId = 27
                        }

                        const isWarehouseShipAddr = getIsWarehouseShipAddr([eachSellerReqItem])
                        let incoTermId = null
                        if (!isWarehouseShipAddr) {
                            incoTermId = 1
                        }

                        const relatedPastSellerPOInfo = pastSellerPOsInfo.find(eachPastSellerPOInfo => eachPastSellerPOInfo.companyId === relatedSellerCompanyDetails.companyId)

                        let isApprovalReq = false
                        console.log("relatedPastSellerPOInfo", relatedPastSellerPOInfo)
                        if (!buyerReq.isRouted){
                            if (relatedPastSellerPOInfo?.approvalRelatedSellerPOCount >= 3){
                                dispatch(raiseToast({ severity: 'error', detail: 'Frequent Seller-PO Payment terms change is not encouraged. Please Update branch/ company level payment terms by contacting Ops admin, or proceed with default payment terms.', life: 3000 }))
                            }else if (nonRoutedSellerPOsInfo && nonRoutedSellerPOsInfo.sellerPOCount >= 5 && nonRoutedSellerPOsInfo.totalAmount > 200000){
                                isApprovalReq = true
                            }
                        }

                        if (!relatedDisplaySellerPO) {
                            relatedDisplaySellerPO = {
                                displaySellerPOId: uuidv4(),
                                buyerPOId: buyerPO?.buyerPOId,
                                buyerReqId: eachSellerReqItem?.buyerReqId,
                                sellerReqId: eachSellerReqItem?.sellerReqId,
                                fileNo: eachSellerReqItem?.fileNo,
                                docNo: eachSellerReqItem?.docNo,
                                companyId: relatedSellerReq?.companyId,
                                pmCompanyId: buyerPO?.pmCompanyId,
                                pmBranchId: buyerPO?.pmBranchId,
                                pmBillAddrId: buyerPO?.pmBillAddrId,
                                branchId: relatedSellerReq?.branchId,
                                billAddrId: sellerBillAddrId,
                                shipAddrId: null,
                                userId: relatedSellerReq?.userId,
                                paymentTerms: paymentTerms,
                                masterPaymentTerms: paymentTerms,
                                numItems: null, //??
                                logisticsBeforeTax: 0,
                                logisticsGSTRate: eachSellerReqItem?.quotGSTRate,
                                logisticsWithTax: null,
                                totalItemAmountBeforeTax: null,
                                totalPOTax: null,
                                totalItemAmountWithTax: null,
                                totalPOAmount: null,
                                isURD: relatedSellerReq?.isURD,
                                logisticsTDSSection: sellerPOTDSSection,
                                logisticsTDSValue: sellerPOTDSValue,
                                statusId: 3,
                                logisticsChargeOption: 'Free Delivery',
                                expenseCategoryId: null,
                                remarks: null,
                                incoTermId: incoTermId,
                                logisticsHSNCode: null,
                                otherTDSValue: null,
                                tdsSectionId: sellerPOTDSSectionId,
                                logisticsGSTRates: [eachSellerReqItem?.quotGSTRate],
                                HSNCodeGSTRates: [],
                                parentDocNo: relatedSellerReq?.docNo,
                                parentFileNo: relatedSellerReq?.fileNo,
                                pmStateId: relatedPMStateId ? relatedPMStateId : null,
                                isApprovalReq: isApprovalReq,
                                paymentTermsLoc: paymentTermsLoc
                            }
                            setDisplaySellerPOs([...displaySellerPOs, relatedDisplaySellerPO])
                        } else {
                            const updatedDisplaySellerPOs = displaySellerPOs.map(eachDisplaySellerPO => {
                                if (eachDisplaySellerPO.displaySellerPOId === relatedDisplaySellerPO.displaySellerPOId) {
                                    const uniqGSTRates = _.uniqBy([...eachDisplaySellerPO.logisticsGSTRates, eachSellerReqItem?.quotGSTRate])
                                    return {
                                        ...eachDisplaySellerPO,
                                        logisticsGSTRates: uniqGSTRates,
                                        logisticsGSTRate: _.maxBy(eachDisplaySellerPO.logisticsGSTRates),
                                        incoTermId: incoTermId,
                                        shipAddrId: null,
                                        paymentTermsLoc: paymentTermsLoc,
                                        isApprovalReq: isApprovalReq
                                    }
                                }
                                return eachDisplaySellerPO
                            })
                            setDisplaySellerPOs(updatedDisplaySellerPOs)
                        }

                        let calculatedUnitPrice = eachSellerReqItem?.quotUnitPrice
                        let calculatedGSTTRate = eachSellerReqItem?.quotGSTRate

                        let relatedSmartStockMoves = []
                        let smartStockMovesToConsume = []
                        let warehouseId = null
                        if (relatedDisplaySellerPO.companyId === relatedDisplaySellerPO.pmCompanyId) {
                            const relatedPMBranch = PMBranches.find(eachPMBranch => eachPMBranch.branchId === relatedSellerReq.branchId)

                            relatedSmartStockMoves = smartStockMoves.filter(eachSmartStockMove => eachSmartStockMove.materialId === eachSellerReqItem.materialId && eachSmartStockMove.warehouseId === relatedPMBranch.warehouseId)

                            const {unitPrice, GSTRate, consumableSmartStockMoves} = calculateStockGSTAndPrice(e.target.value, relatedSmartStockMoves)
                            calculatedUnitPrice = unitPrice
                            calculatedGSTTRate = GSTRate
                            smartStockMovesToConsume = consumableSmartStockMoves
                            warehouseId = relatedPMBranch.warehouseId
                        }
                        eachSellerReqItem.smartUnitPrice = calculatedUnitPrice
                        eachSellerReqItem.smartGSTRate = calculatedGSTTRate

                        let latestBPOItemDeliveryDate = null
                        let latestBPOPunchItemId = null

                        let relatedBPOPunchItems = buyerPOPunchItems.filter(eachPOPunchItem => eachPOPunchItem.buyerPOItemId === buyerPOItem.buyerPOItemId)
            
                        if(relatedBPOPunchItems.length > 0){
                            let latestBPOPunchItem = relatedBPOPunchItems.reduce((latestPunchItem, currentPunchItem) => {
                                return !latestPunchItem || currentPunchItem.poPunchItemId > latestPunchItem.poPunchItemId ? currentPunchItem : latestPunchItem
                            }, relatedBPOPunchItems[0])

                            if (latestBPOPunchItem) {
                                latestBPOPunchItem.expectedDeliveryDate = new Date(latestBPOPunchItem.expectedDeliveryDate)
                                latestBPOItemDeliveryDate = new Date(latestBPOPunchItem.expectedDeliveryDate)
                                latestBPOPunchItemId = latestBPOPunchItem.poPunchItemId
                            }
                        }
                    
                        let newDisplaySellerPOItem = {
                            displaySellerPOItemId: uuidv4(),
                            displaySellerPOId: relatedDisplaySellerPO?.displaySellerPOId,
                            buyerPOId: buyerPO?.buyerPOId,
                            buyerReqId: eachSellerReqItem?.buyerReqId,
                            sellerReqId: eachSellerReqItem?.sellerReqId,
                            buyerReqItemId: eachSellerReqItem?.buyerReqItemId,
                            fileNo: eachSellerReqItem?.fileNo,
                            docNo: eachSellerReqItem?.docNo,
                            shipAddrId: eachSellerReqItem?.shipAddrId,
                            materialId: eachSellerReqItem?.materialId,
                            qty: e.target.value,
                            listPrice: eachSellerReqItem?.quotListPrice,
                            unitPrice: calculatedUnitPrice,
                            HSNCode: eachSellerReqItem?.quotHSNCode,
                            itemAmountBeforeTax: totalAmountBeforeTax,
                            GSTRate: calculatedGSTTRate,
                            itemAmountWithTax: round(totalAmountBeforeTax + totalTax),
                            tdsSection: sellerPOTDSSection,
                            tdsValue: sellerPOTDSValue,
                            tdsAmount: null,
                            sellerRateContractId: null,
                            remarks: null,
                            leadTime: eachSellerReqItem?.quotLeadTime,
                            buyerPOItemId: buyerPOItem.buyerPOItemId,
                            statusId: 3,
                            quotDiscountRate: eachSellerReqItem?.quotDiscountRate,
                            sellerReqItemId: eachSellerReqItem.sellerReqItemId,
                            tdsSectionId: sellerPOTDSSectionId,
                            displayRemarks: false,
                            smartStockMoves: smartStockMovesToConsume,
                            warehouseId: warehouseId,
                            poPunchItemId: latestBPOPunchItemId,
                            expectedClientDeliveryDate: latestBPOItemDeliveryDate,
                            expectedClientDeliveryDateStatus: 1,
                            // followUpStatusId: relatedSellerReq?.companyId === 1 ? 3 : buyerReq.isRouted ? 11 : 10
                        }

                        const relatedMaterialItem = allMaterialDetails.find(eachMaterial => eachMaterial.materialId === eachSellerReqItem?.materialId)

                        if(buyerPO.pmBranchId === 3){
                            newDisplaySellerPOItem.followUpStatusId = 14
                        }else if(relatedMaterialItem && relatedMaterialItem.categoryId === 4){
                            newDisplaySellerPOItem.followUpStatusId = 15
                        }else if(relatedSellerReq.companyId === 1){
                            newDisplaySellerPOItem.followUpStatusId = 3
                        }else if(buyerReq.isRouted){
                            newDisplaySellerPOItem.followUpStatusId = 11
                        }else if(buyerReq.orderTypeId ===3 ){
                            newDisplaySellerPOItem.followUpStatusId = 18
                        }else{
                            newDisplaySellerPOItem.followUpStatusId = 10
                        }

                        setDisplaySellerPOItems([...displaySellerPOItems, newDisplaySellerPOItem])
                    }
                }
                return { ...eachSellerReqItem, createSellerPOQty: e.target.value }
            }
            return eachSellerReqItem
        })
        setSellerReqItems(updatedSellerReqItems)

        if (invalidQtyText) dispatch(raiseToast({ severity: 'warn', detail: invalidQtyText, life: 3000 }))
    }

    const handleSellerUnitPriceChange = (event, sellerReqItemId) => {
        let {isPermitted} = checkPermissions({ ...userDetails, permissions: [139] })

        const relatedInitialSellerReqItem = initialSellerReqItems?.find(eachSelleReqItem => eachSelleReqItem?.sellerReqItemId === sellerReqItemId)
        let previousSellerUnitPrice = relatedInitialSellerReqItem?.quotUnitPrice
        const updatedSellerReqItems = sellerReqItems.map(eachSellerReqItem => {
            if(eachSellerReqItem.sellerReqItemId === sellerReqItemId){
                if (parseFloat(event.target.value) > previousSellerUnitPrice){
                    if (isPermitted){
                        eachSellerReqItem.quotUnitPrice = event.target.value
                    }else{
                        eachSellerReqItem.quotUnitPrice = previousSellerUnitPrice
                        dispatch(raiseToast({ severity: 'error', detail: `Unit Price Can't Be Higher than the previous value.`, life: 3000 }))
                    }
                }else{
                    eachSellerReqItem.quotUnitPrice = event.target.value
                }
            }
            return eachSellerReqItem
        })
        setSellerReqItems(updatedSellerReqItems)
    }

    const handleSellerUnitPriceBlur = (event, sellerReqItemId) => {
        const updatedSellerReqItems = sellerReqItems.map(eachSellerReqItem => {
            if (eachSellerReqItem.sellerReqItemId === sellerReqItemId) {
                if (eachSellerReqItem.quotUnitPrice > eachSellerReqItem.originalQuotUnitPrice) {
                    let {isPermitted} = checkPermissions({ ...userDetails, permissions: [139] })
                    if (isPermitted){
                        eachSellerReqItem.quotUnitPrice = eachSellerReqItem.quotUnitPrice
                    }else{
                        eachSellerReqItem.quotUnitPrice = eachSellerReqItem.originalQuotUnitPrice
                        event.target.value = eachSellerReqItem.originalQuotUnitPrice
                        dispatch(raiseToast({ severity: 'error', detail: `Cant increase unit price more than ${eachSellerReqItem.originalQuotUnitPrice}` }))
                    }
                }
            }
            eachSellerReqItem.quotUnitPrice = round(eachSellerReqItem.quotUnitPrice)
            return eachSellerReqItem
        })
        setSellerReqItems(updatedSellerReqItems)

        const updatedDisplaySellerPOItems = displaySellerPOItems.map(eachSellerPOItem => {
            if (eachSellerPOItem.sellerReqItemId === sellerReqItemId) {
                eachSellerPOItem.unitPrice = round(event.target.value)
                const totalAmountBeforeTax = round(eachSellerPOItem.qty * eachSellerPOItem.unitPrice)
                const totalTax = round((eachSellerPOItem.qty * eachSellerPOItem.unitPrice) * round(eachSellerPOItem.GSTRate / 100))

                eachSellerPOItem.itemAmountBeforeTax = totalAmountBeforeTax
                eachSellerPOItem.itemAmountWithTax = round(totalAmountBeforeTax + totalTax)
            }
            return { ...eachSellerPOItem }
        })
        setDisplaySellerPOItems(updatedDisplaySellerPOItems)
    }

    const handlMaterialEditClick = async() => {
        setIsLoading(true)
        const materialMasterTempRes = await materialIdExistsInOtherRequirement(materialDetails)
        console.log("materialMasterTemp-Response", materialMasterTempRes)
        setIsLoading(false)
        let isMaterialIdExistsinOtherReq = false
        if (materialMasterTempRes.failure) {
            dispatch(raiseToast({ severity: 'error', summary: "Temp Material", detail: materialMasterTempRes.data.error, life: 3000 }))
        }else{
            if(materialMasterTempRes.data){
                isMaterialIdExistsinOtherReq = true
                dispatch(raiseToast({ 
                    severity: 'warn', 
                    summary: "Temp Material", 
                    detail: `Can't update material specs. Material ${materialMasterTempRes.data.materialId} is already present in another requirement ${materialMasterTempRes.data.docNo}`, 
                    life: 3000 
                }))
            }
        }

        const updatedMaterialDetails = allMaterialDetails.map(eachMaterial => {
            if (eachMaterial.materialId === materialDetails.materialId) {
                return { ...eachMaterial, isEditable: true,  isMaterialIdExistsinOtherReq}
            }
            return eachMaterial
        })
        setAllMaterialDetails(updatedMaterialDetails)
    }

    const handleMaterialDetailsChange = async (event) => {
        let updatedMaterialDetails = await Promise.all(allMaterialDetails.map(async (eachMaterial) => {
            if (eachMaterial.materialId === materialDetails.materialId) {
                let updatedMaterialDetail = { ...eachMaterial}
                if(event.target.name === "brand" && typeof(event.target.value) === "object" && event.target.value !== null){
                    updatedMaterialDetail = { ...eachMaterial, [event.target.name]: event.target.value.brandId, brandId: event.target.value.brandId }
                } else if(event.target.name === 'directlySendToPartialSpecsApproval'){
                    updatedMaterialDetail = { ...eachMaterial, directlySendToPartialSpecsApproval: event.checked }
                }
                else{
                    updatedMaterialDetail = { ...eachMaterial, [event.target.name]: event.target.value }
                }

                if(event.target.name === "categoryId"){
                    updatedMaterialDetail = await getCentralAssignUserIdByCategoryId(updatedMaterialDetail)
                }
                return updatedMaterialDetail
            }
            return eachMaterial
        }))

        setAllMaterialDetails(updatedMaterialDetails)
    }

    const getCentralAssignUserIdByCategoryId = (materialDetails) => {
        let categoryUsers = materialIdTeam?.filter(user => user.accessType === "CATEGORY" && user.accessEntity === materialDetails.categoryId)

        if(categoryUsers.length){
            const randomNumber = Math.floor(Math.random() * (categoryUsers.length - 1))

            const updatedMaterialDetails = {...materialDetails, assigneeCentralUserId: categoryUsers[randomNumber].userId}
            return updatedMaterialDetails
        } else {
            return materialDetails
        }
    }

    const handleMaterialDiscard = () => {
        if (window.confirm('Do you want to discard the changes?')) {
            const relatedInitialMaterialDetails = initialMaterialDetails.find(eachMaterial => eachMaterial.materialId === materialDetails.materialId)

            const updatedMaterialDetails = allMaterialDetails.map(eachMaterial => {
                if (eachMaterial.materialId === materialDetails.materialId) {
                    return relatedInitialMaterialDetails
                }
                return eachMaterial
            })
            setAllMaterialDetails(updatedMaterialDetails)
        }
    }

    const handleMaterialEditValidations = async () => {
        const relatedMaterial = allMaterialDetails.find(eachMaterial => eachMaterial.materialId === materialDetails.materialId)

        if (!relatedMaterial.productName) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter product name!', life: 3000 }))
        }

        if (!relatedMaterial.productSpecification) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter specifications!', life: 3000 }))
        }

        if (!relatedMaterial.brand && !(typeof (relatedMaterial.brand) === 'number')) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter brand!`, life: 3000 }))
        }

        if (!relatedMaterial.categoryId) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter category!', life: 3000 }))
        }

        const relatedCategory = materialCategories.find(each => each.categoryId === relatedMaterial?.categoryId)
        const relatedCategoryName = relatedCategory?.categoryName
        const data = {
            productName : relatedMaterial.productName,
            productSpecification: relatedMaterial.productSpecification,
            variantName: relatedMaterial.variantName ? relatedMaterial.variantName : ""
        }
        
        setIsLoading(true)
        const response = await validateMaterialCategoryUsingParser(data) // validateMaterialCategory(data)
        setIsLoading(false)
        if (response.failure) {
            setIsLoading(false)
            await handleMaterialSaveClick(relatedMaterial)
        }
        else {
            let predictedCategory = null
            if(response.data.category){
                predictedCategory = response.data.category
            }
            if (predictedCategory != relatedCategoryName) {
                setPredictedCategory(predictedCategory)
                setSelectedCategory(relatedCategoryName)
                setIsCategoryValidationVisible(true)
            } else {
                await handleMaterialSaveClick(relatedMaterial)
            }
        }
    }
    
    const handleMaterialSaveClick = async (materialDetails) => {
        let categoryUsers = materialIdTeam?.filter(user => user.accessType === "CATEGORY" && user.accessEntity === materialDetails.categoryId)

        if(categoryUsers.length){
            const randomNumber = Math.floor(Math.random() * (categoryUsers.length - 1))

            materialDetails.assigneeCentralUserId = categoryUsers[randomNumber].userId
        }

        if(materialDetails.directlySendToPartialSpecsApproval){
            materialDetails.priority = 1
            materialDetails.statusId = 7
            materialDetails.partialSpecsOnly = true
        }

        if (window.confirm('Do you want to save the changes?')) {
            setIsLoading(true)
            setIsCategoryValidationVisible(false)

            const materialMasterTempRes = await updatedMaterialMasterTemp(materialDetails)
            console.log("materialMasterTempRes", materialMasterTempRes)
            if (materialMasterTempRes.failure) {
                setIsLoading(false)
                return dispatch(raiseToast({ severity: 'error', summary: "Temp Material", detail: materialMasterTempRes.data.error, life: 3000 }))
            }

            const updatedMaterialDetails = allMaterialDetails.map(eachMaterial => {
                if (eachMaterial.materialId === materialDetails.materialId) {
                    return { ...materialDetails, ...materialMasterTempRes.data[0], isEditable: false }
                }
                return eachMaterial
            })

            if(materialDetails.directlySendToPartialSpecsApproval){
                let relatedMaterialSpecsMatchesData = materialSpecsMatchesData.filter(eachMaterial => eachMaterial.materialId != materialDetails.materialId )
                props.setMaterialSpecsMatchesData(relatedMaterialSpecsMatchesData)
            }else{
                let materialItems = [{
                    materialId: materialDetails.materialId,
                    productName: materialDetails.productName,
                    variantName: materialDetails.variantName || '',
                    categoryId: materialDetails.categoryId
                }]

                props.handleCheckMaterialsAreInMaterialSpecs(materialItems)

            }
            let tempMaterialIds = []
            const updatedTempMaterialItems = tempMaterialItems.map(eachMaterial => {
                tempMaterialIds.push(eachMaterial.materialId)
                if (eachMaterial.materialId === materialDetails.materialId) {
                    return { ...materialDetails, ...materialMasterTempRes.data[0], isEditable: false }
                }
                return eachMaterial
            })

            props.getPartialSpecsApprovalInstances(tempMaterialIds)
            setIsLoading(false)
            props.setTempMaterialItems(updatedTempMaterialItems)
            setAllMaterialDetails(updatedMaterialDetails)
        }
    }

    const addGoogleChatIcon = (name, email) => {
        return (
            <>
                <span className="ml-1" style={{color: "#00baaa"}}>{name}</span>
                <a style={{ cursor: "pointer" }} onClick={() => handleGetGoogleUserChatUri(email)}>
                    <img
                        className="mr-1 mb-0 mt-0"
                        src={googleChatIcon}
                        style={{ height: 14 }}
                        alt="Google Chat"
                    />
                </a>
            </>
        )
    }

    const getMaterialMasterApproverTooltiptext = () => {
        let primaryApprover = '-'
        if (materialDetails?.assigneeCentralUserId) {
            const primaryUserDetails = userDetails?.PMCompanyDetails?.companyUsers.find(eachUser => eachUser.userId === materialDetails?.assigneeCentralUserId)
            if(primaryUserDetails){
                primaryApprover = addGoogleChatIcon(getFullName(primaryUserDetails.firstName, primaryUserDetails.lastName), primaryUserDetails.emailId)
            }            
        }
    
        let secondaryApprover = '-'
        if (materialIdTeam?.length) {
            const relatedMaterialIdTeams = materialIdTeam.filter(eachApprover => eachApprover.accessEntity === materialDetails?.categoryId)
            if (relatedMaterialIdTeams) {
                const secondaryUserDetails = relatedMaterialIdTeams.map(eachMaterilaIdMember => {
                    return userDetails?.PMCompanyDetails?.companyUsers.find(eachUser => eachUser.userId === eachMaterilaIdMember.userId)
                })
                secondaryApprover = secondaryUserDetails.map((eachUserDetails, index) => (
                    <span key={index}>
                        {addGoogleChatIcon(getFullName(eachUserDetails?.firstName, eachUserDetails?.lastName), eachUserDetails?.emailId)}
                        {index < secondaryUserDetails.length - 1 && ', '}
                    </span>
                ))
                // secondaryApprover = secondaryUserDetails.map(eachUserDetails => 
                //     addGoogleChatIcon(getFullName(eachUserDetails?.firstName, eachUserDetails?.lastName), eachUserDetails?.emailId)
                // ).join(', ')
            }
        }
    
        const differenceInMillis = new Date() - new Date(materialDetails.createdAt)
        const differenceInHours = differenceInMillis / (1000 * 60 * 60)
    
        let partialSpecsApprover = ''
        let partialSpecsApprovalStatus = 1
        if (materialDetails.partialSpecsOnly) {
            const partialSpecsApproverDetails = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === partialSpecsApproval.primaryApprover)
            if(partialSpecsApproverDetails){
                partialSpecsApprover = addGoogleChatIcon(getFullName(partialSpecsApproverDetails.firstName, partialSpecsApproverDetails.lastName), partialSpecsApproverDetails.emailId)
            }
    
            const relatedApprovalInstance = approvalInstances.find(eachApprovalInstance => eachApprovalInstance.materialId === materialDetails.materialId)
            if (relatedApprovalInstance) {
                partialSpecsApprovalStatus = relatedApprovalInstance.statusId
            }
        }
    
        if (materialDetails?.assigneeCentralUserId && differenceInHours < 1) {
            return getMaterialMasterApproverTooltipHTML(primaryApprover, partialSpecsApprover, partialSpecsApprovalStatus)
        } else {
            const materialCreatedAtDate = new Date(materialDetails.createdAt)
            const materialUpdatedAtDate = new Date(materialDetails.updatedAt)
            if(materialCreatedAtDate.getTime() === materialUpdatedAtDate.getTime() || !materialDetails?.assigneeCentralUserId){
                return getMaterialMasterApproverTooltipHTML(secondaryApprover, partialSpecsApprover, partialSpecsApprovalStatus)
            } else {
                return getMaterialMasterApproverTooltipHTML(primaryApprover, partialSpecsApprover, partialSpecsApprovalStatus)
            }
        }
    }

    const renderPartialSpecsApprovarDetails = () => {
        let partialSpecsApprover = ''
        let partialSpecsApprovalStatus = 1
        if (materialDetails.partialSpecsOnly) {
            const partialSpecsApproverDetails = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === partialSpecsApproval.primaryApprover)
            partialSpecsApprover = getFullName(partialSpecsApproverDetails?.firstName, partialSpecsApproverDetails?.lastName)

            const relatedApprovalInstance = approvalInstances.find(eachApprovalInstance => eachApprovalInstance.materialId === materialDetails.materialId)

            if (relatedApprovalInstance) {
                partialSpecsApprovalStatus = relatedApprovalInstance.statusId
            }
        }
        let partialSpecsApprovalText = ''
        if (partialSpecsApprover) {
            if (partialSpecsApprovalStatus === 12) {
                // partialSpecsApprovalText = `RAISED to ${partialSpecsApprover} for partial Specs approval.`
                partialSpecsApprovalText = (
                    <>
                        RAISED to 
                        <span className="ml-1" style={{color: "#00baaa"}}>{partialSpecsApprover}</span>
                        <a style={{ cursor: "pointer" }} onClick={() => handleGetGoogleUserChatUri()}>
                            <img
                                className="mr-1 mb-0 mt-0"
                                src={googleChatIcon}
                                style={{ height: 15 }}
                                alt="Google Chat"
                            />
                        </a>   
                        for partial specs approval.
                    </>
                )
            }
            else if (partialSpecsApprovalStatus === 8) {
                // partialSpecsApprovalText = `REJECTED by ${partialSpecsApprover} for partial Specs approval.`
                partialSpecsApprovalText = (
                    <>
                        REJECTED by 
                        <span className="ml-1" style={{color: "#00baaa"}}>{partialSpecsApprover}</span>
                        <a style={{ cursor: "pointer" }} onClick={() => handleGetGoogleUserChatUri()}>
                            <img
                                className="mr-1 mb-0 mt-0"
                                src={googleChatIcon}
                                style={{ height: 15 }}
                                alt="Google Chat"
                            />
                        </a> 
                        for partial specs approval.
                    </>
                )
            }
        }
    
        return(
            <p className="m-0 p-0">
                {partialSpecsApprovalText}
            </p>
        )
    }

    const renderPartialSpecsApprovarDetailsToolTipText = () => {
        // let relatedRejectApprovalInstances = approvalInstances.filter(eachApprovalInstance => eachApprovalInstance.approvalId === 28 && eachApprovalInstance.materialId === materialDetails.materialId && eachApprovalInstance.statusId === 8) // APPROVAL_CHANGE find by typeId
        let relatedRejectApprovalInstances = approvalInstances.filter(eachApprovalInstance => {
            const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === eachApprovalInstance.approvalId)
            if (relatedApproval.approvalTypeId === 15 && eachApprovalInstance.materialId === materialDetails.materialId && eachApprovalInstance.statusId === 8){
                return true
            }
            return false
        })
        if (relatedRejectApprovalInstances.length) {
            let rejectedMaterialApprovalInstance = null
            let rejectedUserName = null
            if (relatedRejectApprovalInstances.length === 1) {
                rejectedMaterialApprovalInstance = relatedRejectApprovalInstances[0]
            } else {
                let sortedApprovalInstances = sortArrayOfObjectsInAscendingDateOrder(relatedRejectApprovalInstances)
                rejectedMaterialApprovalInstance = sortedApprovalInstances[0]
            }

            let relatedUser = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === rejectedMaterialApprovalInstance.processedBy)
            if (relatedUser) {
                rejectedUserName = getFullName(relatedUser.firstName, relatedUser.lastName)
            }

            return (
                <>
                    {
                        materialDetails.partialSpecsOnly && rejectedMaterialApprovalInstance ?
                            <Tooltip target={`.material-master-temp-${materialDetails?.materialId}-tooltip`} autoHide >
                                {
                                    rejectedMaterialApprovalInstance &&
                                    `Partial Specs rejected by ${rejectedUserName}, with remarks: ${rejectedMaterialApprovalInstance.processedRemarks}`
                                }
                            </Tooltip>
                            : null
                    }
                </>
            )
        }

        return null
    }

    const handleGetGoogleUserChatUri = async(approvalEmail) => {
        // const partialSpecsApproverDetails = userDetails.PMCompanyDetails.companyUsers.find(eachUser => eachUser.userId === partialSpecsApproval.primaryApprover)
        if(!approvalEmail){
            return dispatch(raiseToast({ severity: 'error', detail: "Approval user not found. Please contact tech team", life: 3000 }))
        }
        let data = {
            userId: userId, 
            emailId: approvalEmail // partialSpecsApproverDetails.email
        }
        setIsLoading(true)
        const getGoogleUserChatUriRes = await getGoogleUserChatUri(data)
        setIsLoading(false)

        if (getGoogleUserChatUriRes.failure) {
            if(window.confirm("Chat with the user doesn't exist.\nPlease open chat manually, and send the message.")){
                window.open("https://mail.google.com/mail/u/0/?tab=rm&ogbl#chat/home", '_blank') 
            }
        }else{
            window.open(getGoogleUserChatUriRes.data, '_blank')
        }
    }

    const searchBrands = (event) => {
        const relatedBrands = brandData.filter(brand => brand.brandName.toLowerCase().includes(event.query.trim().toLowerCase()))
        setSearchedMaterialBrands([...relatedBrands])
    }

    const handleCopyPaste = (e) => {
        e.preventDefault()
    }

    const handlevisibleStructuredMaterialSpecs = () => {
        setVisibleStructuredMaterialSpecs(true)
    }

    const getMissingMaterialSpecsAttriabutes = () => {
        let missingSpecsAttributes = []
        let relatedMaterialSpecs = []

        console.log("materialDetails", materialDetails)
        
        if (materialDetails.materialId.toString().length === 6 && materialSpecifications.length) {
            relatedMaterialSpecs = materialSpecifications.filter(spec =>
                materialDetails.categoryId === spec.categoryId &&
                materialDetails.productName.toLowerCase() === spec.productName.toLowerCase() &&
                materialDetails.variantName?.toLowerCase() === spec.variantName.toLowerCase() &&
                !materialDetails.partialSpecsOnly
            )

            if (relatedMaterialSpecs.length) {
                let productSpecificationJSON = []
                if (materialDetails.productSpecificationJSON) {
                    productSpecificationJSON = materialDetails.productSpecificationJSON.map(jsonString => JSON.parse(jsonString))
                }

                relatedMaterialSpecs.forEach((spec) => {
                    if (spec.materialSpecificationMandatoryTypeId === 1) {
                        const hasAttribute = productSpecificationJSON.some(
                            attr => attr.type?.toLowerCase() === spec.attribute.toLowerCase() && attr.value
                        )

                        if (!hasAttribute) {
                            missingSpecsAttributes.push({
                                name: spec.attribute,
                                unit: spec.attributeUnit,
                            })
                        }
                    }
                })
            }
        }

        return {relatedMaterialSpecs, missingSpecsAttributes}
    }

    const renderMissingSpecsAttributesText = () => {
        let contactPerson = addGoogleChatIcon(getFullName("Kalyan", "Penumudi"), "kalyan_penumudi@procmart.com")
        return(
            <p className="m-0 p-0">
                <span style={{color: "red"}}>This material is missing mandatory specification attributes.</span> 
                <span className="font-bold" style={{color: "black"}}> Please contact</span> 
                {contactPerson} or the codification team.
            </p>
        ) 
    }

    const remainingQty = getRemainingQty(buyerPOItem?.availableQty, relatedSellerReqItems)

    const relatedStockMaterial = stockMaterials?.find(eachStockMaterial => eachStockMaterial?.materialId === materialDetails?.materialId)
    let useStockClassName = ""
    if (relatedStockMaterial?.materialId) {
        useStockClassName = " "
    } else {
        useStockClassName = "h-2rem action-btn hover:surface-400 hover:text-700 surface-300"
    }

    const relatedBuyerQuoteItems = buyerQuoteItems?.filter(eachBuyerQuoteItem => eachBuyerQuoteItem?.buyerReqItemId === buyerPOItem?.buyerReqItemId && eachBuyerQuoteItem?.statusId === 1 && eachBuyerQuoteItem?.totReqQty > 0)
    let totalSellerQuotPrice = 0
    relatedBuyerQuoteItems?.map(eachBuyerQuoteItem => {
        totalSellerQuotPrice += parseFloat(eachBuyerQuoteItem?.bQuotSellerPrice)
    })

    let materialSpecsDiableCond = lowPriorityMaterials.length === 0 
    if (materialDetails){
        materialSpecsDiableCond = materialSpecsDiableCond || !materialDetails.isEditable
    }
    let brandName = ''
    if(materialDetails && typeof(materialDetails.brand) === "number"){
        const relatedBrand = brandData.find(eachBrand => eachBrand.brandId === materialDetails.brand)
        if(relatedBrand){
            brandName = relatedBrand.brandName
        }
    }else{ 
        brandName = materialDetails.brand 
    }
    
    let relatedMaterialSpecsMatchData = materialSpecsMatchesData.find(eachMaterial => eachMaterial.materialId === materialDetails.materialId)

    let relatedStructuredMaterialSpecs = null
    let relatedSpecifications = []
    let structuredMaterialsSpecs = {}
    let materialMissingSpecsAttributes = []
    if(relatedMaterialSpecsMatchData){
        relatedSpecifications = materialSpecifications.filter(
            (spec) =>
                spec.categoryId === materialDetails.categoryId &&
                spec.productName?.toLowerCase() === relatedMaterialSpecsMatchData.matchedProduct.toLowerCase()
        )
    }else{
        let {relatedMaterialSpecs, missingSpecsAttributes} = getMissingMaterialSpecsAttriabutes()
        relatedSpecifications = relatedMaterialSpecs
        materialMissingSpecsAttributes = missingSpecsAttributes
    }
    
    if (relatedSpecifications.length) {
        relatedSpecifications.forEach((spec) => {
            const product = spec.productName
            const variant = spec.variantName
            const attribute = `${spec.attribute}${spec.attributeUnit ? ` (${spec.attributeUnit})` : ""}`

            if (!structuredMaterialsSpecs[product]) {
                structuredMaterialsSpecs[product] = {}
            }

            if (!structuredMaterialsSpecs[product][variant]) {
                structuredMaterialsSpecs[product][variant] = {
                    mandatoryParams: new Set(),
                    nonMandatoryParams: new Set(),
                };
            }

            if (spec.materialSpecificationMandatoryTypeId === 1) {
                structuredMaterialsSpecs[product][variant].mandatoryParams.add(attribute)
            } else {
                structuredMaterialsSpecs[product][variant].nonMandatoryParams.add(attribute)
            }
        })

        Object.keys(structuredMaterialsSpecs).forEach((product) => {
            Object.keys(structuredMaterialsSpecs[product]).forEach((variant) => {
                const spec = structuredMaterialsSpecs[product][variant]
                spec.mandatoryParams = Array.from(spec.mandatoryParams)
                spec.nonMandatoryParams = Array.from(spec.nonMandatoryParams)
            })
        })

        if (Object.keys(structuredMaterialsSpecs).length > 0) {
            relatedStructuredMaterialSpecs = structuredMaterialsSpecs
        }
    }

    const relatedPastSellerPOMaterialTransactions = pastSellerPOMaterialTransactions.filter(eachSelPOMaterial => eachSelPOMaterial.materialId === materialDetails?.materialId)

    let materialCardBackgroundColor = ""
    if(materialDetails){
        if(materialDetails.materialId.toString().length >= 7 && materialDetails.priority === 1){
            materialCardBackgroundColor =  "#f7f1e4"
        }
        else if(materialDetails.materialId.toString().length >= 7 || (materialMissingSpecsAttributes.length && relatedSpecifications.length)){
            materialCardBackgroundColor = "#faf0f0"
        }else{
            materialCardBackgroundColor = "#edf2ef"
        }
    }
    
    return (
        <>
            {
                materialDetails &&
                <div className="p-card col-12 mb-2 xl:col-12 m-0 create-sellerpo-product-list-items" style={{ padding: 0, backgroundColor: materialCardBackgroundColor }} >

                    {/*Product Details*/}
                    {
                        (materialDetails.materialId.toString().length >= 7) ?
                            <div className="my-2 mx-2">
                                <div className={`flex flex-row justify-content-between ${materialDetails.priority === 1 || materialDetails.partialSpecsOnly ? "justify-content-between" : "justify-content-end"}`}>
                                    {
                                        materialDetails.priority !== 1 && !materialDetails.partialSpecsOnly ?
                                            <div>
                                                <CheckboxField label="Directly send for partial specs approval" name="directlySendToPartialSpecsApproval" value="directlySendToPartialSpecsApproval" onChange={handleMaterialDetailsChange} checked={materialDetails?.directlySendToPartialSpecsApproval} disabled={materialSpecsDiableCond} />
                                            </div>
                                            : null
                                    }
                                    {
                                        materialDetails.priority === 1 && getMaterialMasterApproverTooltiptext()
                                    }
                                    {
                                        relatedMaterialSpecsMatchData && relatedStructuredMaterialSpecs ?
                                            <div>
                                                <span className="ml-2">
                                                    Jaadu identified this product is structured:
                                                    <a
                                                        onClick={() => handlevisibleStructuredMaterialSpecs()}
                                                        className="view-btn ml-1"
                                                        style={{ cursor: "pointer", fontSize: "13px", color: "#00baaa" }}
                                                    >
                                                        View Mandatory Params
                                                    </a>
                                                </span>
                                            </div>
                                            : null
                                    }
                                </div>
                            </div>
                            :
                            materialMissingSpecsAttributes.length && relatedSpecifications.length ? 
                                <div className="my-2 mx-2">
                                    <div className={`flex flex-row justify-content-between`}>
                                        {
                                            renderMissingSpecsAttributesText(materialDetails.missingSpecsAttributes)
                                        }
                                        {
                                            <div>
                                                <span className="ml-2">
                                                    Jaadu identified this product is structured:
                                                    <a
                                                        onClick={() => handlevisibleStructuredMaterialSpecs()}
                                                        className="view-btn ml-1"
                                                        style={{ cursor: "pointer", fontSize: "13px", color: "#00baaa" }}
                                                    >
                                                        View Mandatory Params
                                                    </a>
                                                </span>
                                            </div>
                                        }
                                    </div>
                                </div>
                                : null
                    }
                    <div className="grid col-12 lg:col-12 md:col-12 align-items-center" style={{ padding: 10, paddingBottom: 10 }} >
                        <div className={`flex flex-column col-12 md:col-2 lg:col-1 material-id ${lowPriorityMaterials.length === 0 ? `material-master-temp-${materialDetails?.materialId}-tooltip` : ''} `}>
                            <TextInputField labelText="Material Id" value={materialDetails?.materialId} disabled />
                        </div>
                        {/* <div className="flex flex-column col-12 md:col-2 lg:col-2 pl-0">
                            <TextInputField labelText="Product" name='productName' value={materialDetails?.productName} disabled={materialSpecsDiableCond || materialDetails?.isMaterialIdExistsinOtherReq} onChange={handleMaterialDetailsChange} tooltip={materialDetails?.productName} tooltipOptions={{ position: 'top', showOnDisabled: true }} />
                        </div>
                        <div className="flex flex-column col-12 md:col-2 lg:col-1 pl-0">
                            <TextInputField labelText="Variant" name='variantName' value={materialDetails?.variantName} disabled={materialSpecsDiableCond || materialDetails?.isMaterialIdExistsinOtherReq} onChange={handleMaterialDetailsChange} tooltip={materialDetails?.productName} tooltipOptions={{ position: 'top', showOnDisabled: true }} />
                        </div> */}
                        {
                            materialSpecsDiableCond || materialDetails?.isMaterialIdExistsinOtherReq ?
                                <div className="flex flex-column col-12 md:col-2 lg:col-2 pl-0">
                                    <TextInputField labelText="Product | Variant" name='productName' value={`${materialDetails?.productName}${materialDetails?.variantName ? ` | ${materialDetails?.variantName}` : ""}`} disabled={materialSpecsDiableCond || materialDetails?.isMaterialIdExistsinOtherReq} tooltip={`${materialDetails?.productName}${materialDetails?.variantName ? ` | ${materialDetails?.variantName}` : ""}`} tooltipOptions={{ position: 'top', showOnDisabled: true }} />
                                </div> 
                                    :
                                <>
                                    <div className="flex flex-column col-12 md:col-2 lg:col-1 pl-0">
                                        <TextInputField labelText="Product" name='productName' value={materialDetails?.productName} disabled={materialSpecsDiableCond || materialDetails?.isMaterialIdExistsinOtherReq} onChange={handleMaterialDetailsChange} tooltip={materialDetails?.productName} tooltipOptions={{ position: 'top', showOnDisabled: true }} />
                                    </div>
                                    <div className="flex flex-column col-12 md:col-2 lg:col-1 pl-0">
                                        <TextInputField labelText="Variant" name='variantName' value={materialDetails?.variantName} disabled={materialSpecsDiableCond || materialDetails?.isMaterialIdExistsinOtherReq} onChange={handleMaterialDetailsChange} tooltip={materialDetails?.variantName} tooltipOptions={{ position: 'top', showOnDisabled: true }} />
                                    </div>
                                </>
                        }
                        <div className="flex flex-column col-12 md:col-3 lg:col-3 pl-0" style={{width: "400px"}}>
                            <TextInputField labelText="Specification" name="productSpecification" value={materialDetails?.productSpecification} disabled={materialSpecsDiableCond || materialDetails?.isMaterialIdExistsinOtherReq} onChange={handleMaterialDetailsChange} tooltip={materialDetails?.productSpecification} tooltipOptions={{ position: 'top', showOnDisabled: true, showDelay: 500, hideDelay: 150 }} />
                        </div>
                        <div className="flex flex-column col-12 md:col-3 lg:col-1 pl-0" style={{width: "100px"}}>
                            <AutoCompleteField name="brand" value={brandName} field="brandName" labelText="Brand" searchMethod={searchBrands} suggestions={searchedMaterialBrands} onChange={handleMaterialDetailsChange} disabled={materialSpecsDiableCond || materialDetails?.isMaterialIdExistsinOtherReq} forceSelection onPaste={(e)=>handleCopyPaste(e)} />
                            {/* <TextInputField name="brand" value={relatedBrand.brandName} labelText="Brand" keyfilter="num" disabled /> */}
                        </div>
                        <div className="flex flex-column col-12 md:col-3 lg:col-2 pl-0" style={{width: "200px"}}>
                            <DropDownField name="categoryId" value={materialDetails?.categoryId} options={materialCategories} labelText="Category" optionLabel="categoryName" optionValue="categoryId" onChange={handleMaterialDetailsChange} disabled={materialSpecsDiableCond} />
                        </div>
                        <div className="flex flex-column col-12 md:col-1 lg:col-1 pl-0" style={{width: "80px"}}>
                            <TextInputField labelText="List Price" name="bQuotListPrice" value={buyerPOItem?.bPOListPrice} keyfilter="num" disabled />
                        </div>
                        {/*<div className="flex flex-column col-12 md:col-1 lg:col-1">
                            <TextInputField labelText="Avg. S.Price" name="" value={avgSellerQuotPrice} keyfilter="num" disabled />
                        </div>*/}
                        <div className="flex flex-column col-12 md:col-2 lg:col-1 pl-0">
                            <label htmlFor="availableQty" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                Avl Qty
                                <Tooltip target=".available-qty-icon" position="top" content="Total PO punch qty that is remaining to create seller PO for this product" />
                                <i className="pi pi-info-circle available-qty-icon ml-1"></i>
                            </label>
                            <TextInputField name="quantity" value={`${remainingQty}/${buyerPOItem?.availableQty}`} id="availableQty" keyfilter="num" disabled />
                        </div>
                        <div className={`flex col-12 md:col-3 lg:col-3 pt-0 pb-0 pr-0`}>
                            {materialDetails.materialId.toString().length >= 7 && materialDetails.priority != 1 ? // lowPriorityMaterials.length !== 0 && 
                                <>{
                                    materialDetails.isEditable ?
                                        <div className="flex flex-row align-items-center">
                                            <Button className="small-btn discard-btn mr-1 mt-3" label="Discard" style={{ fontSize: "12px" }} onClick={(e) => { handleMaterialDiscard() }} />
                                            <Button className="small-btn mr-1 mt-3" label="Save" style={{ fontSize: "12px", border: 0, backgroundColor: "purple" }} onClick={() => handleMaterialEditValidations()} />
                                        </div>
                                        :
                                        <div className="flex flex-row align-items-center mr-1" >
                                            <Button className='small-btn mt-3' label="Edit" style={{ fontSize: "12px" }} onClick={() => handlMaterialEditClick()} />
                                        </div>
                                }</> : null}
                            <div className="flex flex-row justify-content-end" >
                                <Button 
                                    className={`${useStockClassName} mt-3`} 
                                    label="Use Stock" 
                                    style={{ fontSize: "12px" }} 
                                    onClick={() => handleUseStock(buyerPOItem?.buyerPOItemId)} 
                                    disabled={buyerReq.orderTypeId===3} 
                                    tooltip={buyerReq.orderTypeId===3 ? `Can't use useStock in stock requirement(ordertype = STOCK)` : ''}
                                    tooltipOptions={{ position: 'top', showOnDisabled: true, showDelay: 500, hideDelay: 150 }}
                                />
                            </div>
                            <div>
                                <MaterialsPreviousTransactions
                                    relatedPastSellerPOMaterialTransactions={relatedPastSellerPOMaterialTransactions}
                                    isPrevSelPOMaterialTransactionsLoading={false}
                                    PMCompanyConfig={PMCompanyConfig}
                                    tiggerPastTransactions={tiggerPastTransactions}
                                />
                            </div>
                        </div>
                        {
                            materialDetails.materialId.toString().length >= 7 && materialDetails.partialSpecsOnly ? 
                                renderPartialSpecsApprovarDetailsToolTipText() 
                                : null
                        }
                    </div>

                    {/*Sellers*/}
                    {relatedSellerReqItems.map((eachSellerReqItem, index) => {
                        const displayLabel = index === 0

                        const relatedSellerReq = sellerReqs.find(eachSellerReq => eachSellerReq.sellerReqId === eachSellerReqItem.sellerReqId)
                        const relatedSellerCompanyDetails = sellerCompanyDetails.find(eachSellerName => eachSellerName.sellerReqId === relatedSellerReq.sellerReqId)

                        const relatedVendorRateContract = vendorRateContracts.find(eachVendorRc => {
                            const isBranchPresent = Object.keys(eachVendorRc.geoMap).includes(buyerReq.pmBranchId.toString())
                            const isVRCSellerCompany = relatedSellerReq?.companyId === eachVendorRc.companyId
                            if(isBranchPresent && isVRCSellerCompany){
                                return eachVendorRc
                            }
                        })
                        
                        const totalAmountBeforeTax = round(eachSellerReqItem.createSellerPOQty * eachSellerReqItem.quotUnitPrice)
                        const totalTax = round((eachSellerReqItem.createSellerPOQty * eachSellerReqItem.quotUnitPrice) * round(eachSellerReqItem.quotGSTRate / 100))

                        let relatedPMBranch = {}
                        let relatedSmartStockMoves = []
                        if (relatedSellerReq.companyId === relatedSellerReq.pmCompanyId) {
                            relatedPMBranch = PMBranches.find(eachPMBranch => eachPMBranch.branchId === relatedSellerReq.branchId)
                            relatedSmartStockMoves = smartStockMoves.filter(eachSmartStockMove => eachSmartStockMove.materialId === materialDetails.materialId && eachSmartStockMove.warehouseId === relatedPMBranch.warehouseId)
                        }

                        let materialIdTooltip = ''
                        if (materialDetails.materialId.toString().length >= 7) {
                            materialIdTooltip = `Can't create seller PO for temporary material IDs`
                        } else {
                            if(relatedSellerReq.companyId === relatedSellerReq.pmCompanyId){
                                let totalSmartStockQty = 0
                                relatedSmartStockMoves.forEach(eachSmartStockMove => {
                                    totalSmartStockQty += parseFloat(eachSmartStockMove.moveQty)
                                })

                                if(!totalSmartStockQty){
                                    materialIdTooltip = 'Material not available in stock!'
                                }
                                else{
                                    materialIdTooltip = `Stock available in warehouse: ${totalSmartStockQty}`
                                }
                            }
                            if (!eachSellerReqItem.quotHSNCode) {
                                materialIdTooltip = 'Please enter HSN code for this material in seller req!'
                            }
                            if (!eachSellerReqItem.quotLeadTime) {
                                materialIdTooltip = 'Please enter lead time for this material in seller req!'
                            }
                        }

                        let materialIdDisableCond = false
                        if (materialDetails.materialId.toString().length >= 7) {
                            materialIdDisableCond = true
                        }else{
                            if(!eachSellerReqItem.quotHSNCode){
                                materialIdDisableCond = true
                            }
                            if(!eachSellerReqItem.quotLeadTime){
                                materialIdDisableCond = true
                            }
                            if(relatedSellerReq.companyId === relatedSellerReq.pmCompanyId){
                                let totalSmartStockQty = 0
                                relatedSmartStockMoves.forEach(eachSmartStockMove => {
                                    totalSmartStockQty += parseFloat(eachSmartStockMove.moveQty)
                                })

                                if(!totalSmartStockQty){
                                    materialIdDisableCond = true
                                }
                            }
                        }

                        let unitPrice = relatedSellerReq.companyId === relatedSellerReq.pmCompanyId ? eachSellerReqItem.smartUnitPrice : eachSellerReqItem.quotUnitPrice

                        let quotePercentileImg = ''
                        let quotePercentileTooltipText = ''
                        if (relatedPastSellerPOMaterialTransactions.length && relatedPastSellerPOMaterialTransactions.length >= 3 && eachSellerReqItem.quotUnitPrice && eachSellerReqItem.statusId === 1 && relatedSellerReq.companyId !== relatedSellerReq.pmCompanyId) {
                            const allUnitPrices = relatedPastSellerPOMaterialTransactions.map(eachMatTransaction => eachMatTransaction.unitPrice)
                            const percentile = getReversePercentile(allUnitPrices, unitPrice)

                            const minPrice = _.min(allUnitPrices)
                            if (minPrice && minPrice >= unitPrice) {
                                quotePercentileImg = "https://procmart-dev.s3.ap-south-1.amazonaws.com/SellerRegistration/GSTCertificate/ce24ce68-bcde-4fb2-abd7-197073f0f96f.png"
                                quotePercentileTooltipText = `Percentile: ${percentile}`
                            }
                            else if (percentile >= 20) {
                                quotePercentileImg = "https://procmart-dev.s3.ap-south-1.amazonaws.com/SellerRegistration/IncorporationCertificate/045571a6-17cb-437d-a745-44994a03095a.png"
                                quotePercentileTooltipText = `Percentile: ${percentile}`
                            }
                            else if (percentile < 20) {
                                quotePercentileImg = "https://procmart-dev.s3.ap-south-1.amazonaws.com/SellerRegistration/MSMEDCertificate/2834e5ec-72c0-40dd-9368-41ca6c9e971f.png"
                                quotePercentileTooltipText = `We think this item can be at a better price - Have you tried negotiating with the vendor well?`
                            }
                        }
                        let sellerReqBackgroundColor = ""
                        let sellerReqBorderRadius = ""
                        if(eachSellerReqItem.isNewSellerReqItem){
                            sellerReqBackgroundColor = "#f0d1f0"
                            sellerReqBorderRadius = "4px"
                        }

                        const sellerUnitLogistics = eachSellerReqItem.quotLogisticsWithTax ? round(eachSellerReqItem.quotLogisticsWithTax / eachSellerReqItem.quotQty, 2) : 0

                        return (
                            <div className="m-0" style={{ backgroundColor: '', paddingLeft: 10, paddingRight: 10 }} key={`sellerPOItem-${eachSellerReqItem.sellerReqItemId}`}>
                                <div className="grid align-items-center m-0" style={{ backgroundColor: eachSellerReqItem.isNewSellerReqItem ? '#ede9f5': '',  borderRadius: eachSellerReqItem.isNewSellerReqItem ? '4px': ''}}>
                                    <div className="flex col-12 lg:col-2">
                                        <div className="col" style={{ flexGrow: 1 }}>
                                            <p className="m-0" style={{ fontSize: '12px' }}>
                                                {relatedSellerCompanyDetails?.companyName}
                                                <span className="m-0 seller-name">{`${relatedSellerCompanyDetails?.firstName} ${relatedSellerCompanyDetails?.lastName ? relatedSellerCompanyDetails?.lastName : ''}`}</span>
                                                {
                                                    relatedVendorRateContract && <span className="" style={{fontWeight:"bold"}}>{` (VRC)`}</span>
                                                }
                                            </p>
                                            <p className="m-0 text-sm seller-name" style={{ fontSize: '12px' }}></p>
                                        </div>
                                    </div>
                                    <div className="flex col-12 lg:col-10">
                                        <div className="grid">
                                            <div className="flex flex-column col-12 md:col-1 lg:col-1 pl-0 quantity">
                                                <TextInputField
                                                    name="sellerQty"
                                                    value={eachSellerReqItem.createSellerPOQty}
                                                    keyfilter="num"
                                                    required
                                                    // {...(materialDetails.materialId.toString().length >= 7 ? { tooltip: "Can't create seller PO for temporary material IDs", tooltipOptions: { position: 'right', showOnDisabled: true } } : {})}
                                                    tooltip={materialIdTooltip}
                                                    tooltipOptions={{position: 'right', showOnDisabled: true}}
                                                    disabled={materialIdDisableCond || (materialMissingSpecsAttributes.length && relatedSpecifications.length)} labelText={displayLabel && "Quantity"}
                                                    onChange={(e) => handleSellerQuantity(e, eachSellerReqItem.sellerReqItemId, relatedSellerReq, displaySellerPOs, setDisplaySellerPOs, buyerPO, displaySellerPOItems, setDisplaySellerPOItems, buyerPOItem, relatedSellerReqItems, relatedSellerCompanyDetails)}
                                                />
                                            </div>
                                            <div className="flex flex-column col-12 md:col-2 lg:col-1  pl-0 w-5rem seller-qty">
                                                <TextInputField name="sellerLeadTime" value={eachSellerReqItem.quotQty} labelText={displayLabel && "Seller Qty"} keyfilter="num" disabled />
                                            </div>
                                            <div className="flex flex-column col-12 md:col-3 lg:col-1  pl-0 w-5rem del-period">
                                                <TextInputField name="sellerLeadTime" value={eachSellerReqItem.quotLeadTime} labelText={displayLabel && "Del. Period"} keyfilter="num" disabled />
                                            </div>
                                            <div className="flex flex-column col-12 md:col-2 lg:col-1 w-5rem  pl-0 list-price">
                                                <TextInputField name="sellerListPrice" value={eachSellerReqItem.quotListPrice} labelText={displayLabel && "List Price"} disabled />
                                            </div>
                                            <div className="flex flex-column col-12 md:col-2 lg:col-1  pl-0 w-6rem unit-price">
                                                <TextInputField 
                                                    name="quotUnitPrice" 
                                                    value={unitPrice} 
                                                    labelText={displayLabel && "Unit Price"}
                                                    tooltip={relatedSellerReq.companyId === relatedSellerReq.pmCompanyId ? 'This is average unit price!' : ''} 
                                                    tooltipOptions={{ position: 'right', showOnDisabled: true, showDelay: 300, hideDelay: 150 }}
                                                    keyfilter="num" 
                                                    onChange={(event) => handleSellerUnitPriceChange(event, eachSellerReqItem.sellerReqItemId)} 
                                                    onBlur={(event) => handleSellerUnitPriceBlur(event, eachSellerReqItem.sellerReqItemId)} 
                                                    disabled={relatedSellerReq?.companyId === relatedSellerReq?.pmCompanyId} 
                                                    id="quoteUnitPrice" 
                                                />
                                            </div>
                                            <div className="flex flex-column col-12 md:col-2 lg:col-1 w-5rem pl-0 urd">
                                                <DropDownField name="URD" value={relatedSellerReq.isURD ? "Yes" : "No"} options={urdOptions} labelText={displayLabel && "URD"} optionLabel="label" optionValue="value" disabled />
                                            </div>
                                            <div className="flex flex-column col-12  md:col-2 lg:col-1  pl-0 w-5rem">
                                                <TextInputField name="sellerUnitLogistics" value={sellerUnitLogistics} labelText={displayLabel && "Unit Logistics"} disabled />
                                            </div>
                                            <div className="flex flex-column col-12 md:col-2 lg:col-1  pl-0 gst">
                                                <DropDownField 
                                                    name="sellerGSTRate" 
                                                    value={relatedSellerReq.companyId === relatedSellerReq.pmCompanyId ? eachSellerReqItem.smartGSTRate : eachSellerReqItem.quotGSTRate}  
                                                    options={gstOptions} labelText={displayLabel && `${pmCompanyConfig.GSTRateLabel}`} 
                                                    optionLabel="" 
                                                    optionValue="" 
                                                    disabled 
                                                />
                                            </div>
                                            <div className="flex flex-column col-12  md:col-2 lg:col-1  pl-0 w-5rem before-tax">
                                                <TextInputField name="sellerBeforeTax" value={totalAmountBeforeTax} labelText={displayLabel && "Before Tax"} disabled />
                                            </div>
                                            <div className="flex flex-column col-12  md:col-2 lg:col-1  pl-0 total-tax">
                                                <TextInputField name="sellerTotalTax" value={totalTax} labelText={displayLabel && "Total Tax"} disabled />
                                            </div>
                                            <div className="flex flex-column col-12 md:col-2 lg:col-1  pl-0 w-5rem total-amount">
                                                <TextInputField name="sellerTotalPrice" value={round(totalTax + totalAmountBeforeTax)} labelText={displayLabel && "Total Amount"} disabled />
                                            </div>
                                            {
                                                quotePercentileImg &&
                                                <div className="flex flex-column col-12 md:col-2 lg:col-1  pl-0 w-5rem align-items-center">
                                                    <img src={quotePercentileImg} style={{ width: '2rem', height: '2rem' }} className={`quote-percentile-tooltip-${eachSellerReqItem.sellerReqItemId} cursor-pointer`} />
                                                    <Tooltip content={quotePercentileTooltipText} target={`.quote-percentile-tooltip-${eachSellerReqItem.sellerReqItemId}`} />
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            }
            <Dialog header="CATEGORY VALIDATION" visible={isCategoryValidationVisible} style={{ width: '30vw', minHeight: "30vh", }} onHide={() => setIsCategoryValidationVisible(false)}>
                <ValidateCategoryModal handleMaterialSaveClick={handleMaterialSaveClick} predictedCategory={predictedCategory} selectedCategory={selectedCategory} materialDetails={materialDetails} materialCategories={materialCategories} setIsCategoryValidationVisible={setIsCategoryValidationVisible} />
            </Dialog>
            <StructuredMaterialSpecs
                visibleStructuredMaterialSpecs={visibleStructuredMaterialSpecs}
                setVisibleStructuredMaterialSpecs={setVisibleStructuredMaterialSpecs}
                structuredMaterials={relatedStructuredMaterialSpecs}
            />
        </>
    )
}

export default ProductsListItems